import * as n from "react";
var o = /* @__PURE__ */ n.memo(function(e) {
  var r = e.children;
  return r;
}, function(e, r) {
  return r.cache;
});
process.env.NODE_ENV !== "production" && (o.displayName = "PopupContent");
export {
  o as default
};
//# sourceMappingURL=PopupContent.mjs.map
